import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./StepProgressIndicator.css";

const StepProgressIndicator = ({ currentStep }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const steps = [
    {
      title: "Step 1",
      subtitle: "Select Tokens",
      description:
        "Pick from top-performing tokens like BTC and ETH or explore emerging stars like Solana memes and utility coins. Customize your race with the tokens that matter most.",
    },
    {
      title: "Step 2",
      subtitle: "Race Settings",
      description:
        "Define the structure of your race by setting\n1. Duration (1 to 24 hours)\n2. Start time,\n3. how long bets will be accepted.\n\nTailor these rules to create a fair and thrilling competition that suits your strategy.",
    },
    {
      title: "Step 3",
      subtitle: "Handicapping",
      description:
        "Fine-tune your race dynamics by customizing how token performance is evaluated. Adjust the impact of market cap and volatility to create a level playing field or amplify strategic challenges.",
    },
    {
      title: "Step 4",
      subtitle: "Create Pool",
      description:
        "Allocate USDC to your race pool and distribute funds across the selected tokens. Finalize the setup to kick off an exciting and competitive race.",
    },
  ];

  // Filter steps based on screen size
  const stepsToRender = isMobile ? [steps[currentStep - 1]] : steps;

  return (
    <div className="step-progress-indicator-container">
      {stepsToRender.map((step, idx) => {
        const stepNumber = isMobile ? currentStep : idx + 1;
        return (
          <div
            key={stepNumber}
            className={`step-box ${stepNumber === currentStep ? "active" : ""}`}
          >
            <h3>{step.title}</h3>
            <div className="divider"></div>
            <h4>{step.subtitle}</h4>
            <p className="step-description">{step.description}</p>
          </div>
        );
      })}
    </div>
  );
};

StepProgressIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default StepProgressIndicator;
